
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store";

// Vendors
import moment from "moment";

// Models
import {AppPlayerTrainingsRootListIndex} from "@/models/app/player/trainings/root/list/index";
import {AppCommonTrainingCategory} from "@/models/app/common/training-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppPlayerTrainingsRootListFormCreateIndexVue from "@/views/app/player/trainings/root/list/form/create.vue";
import AppPlayerTrainingsRootListFormUpdateIndexVue from "@/views/app/player/trainings/root/list/form/update.vue";
import AppPlayerTrainingsRootListFormRemoveIndexVue from "@/views/app/player/trainings/root/list/form/remove.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  props: [
    "trainingCategories",
  ],
  components: {
    ElRow,
    ElCol,
    AppPlayerTrainingsRootListFormCreateIndexVue,
    AppPlayerTrainingsRootListFormUpdateIndexVue,
    AppPlayerTrainingsRootListFormRemoveIndexVue,
  },
})
export default class AppPlayerTrainingsRootListIndexVue extends Vue {
  isLoading: boolean | null = false;

  formData: any = {
    filter: {
      user_id: store.getters.getAuthentication.id,
      training_category_id: "*",
      date: [
        moment(),
        moment().add(14, "days"),
      ],
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };

  moment: any = null;

  trainingCategories: Array<AppCommonTrainingCategory> = [];
  trainings: Array<AppPlayerTrainingsRootListIndex> = [];

  async getTrainings(formData: any = null): Promise<void> {
    this.isLoading = true;

    if (formData) {
      this.formData = formData;
    }

    await getRequest({
      uri: `/common/trainings`,
      formData: this.formData,
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.trainings = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    this.moment = moment;
    await this.getTrainings();
  }
}
